export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq',
    merge: true,
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
    merge: true,
    className: 'col-border',
    visible: !that.disabled,
  },
  {
    field: 'devTrackingCode',
    width: 120,
    align: 'center',
    fixed: 'left',
    visible: false,
    mergeByKey: true,
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'displayImage',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayName') || '样品名称',
    field: 'displayName',
    minWidth: 220,
    align: 'left',
    fixed: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_goodsSizeSpec') || '尺寸颜色',
    field: 'goodsSizeSpec',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fabricContent') || '面料构成',
    field: 'fabricContent',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_scm') || '成品工厂',
    field: 'scmName',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_quotationMethod') || '报价方式',
    field: 'v_quotationMethod',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_quotationCasePack') || '装箱入数',
    field: 'quotationCasePack',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_quotationPrice') || '报价产品单价',
    field: 'quotationPrice',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_quotationCurrencyUnit') || '报价货币单位',
    field: 'v_quotationCurrencyUnit',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    className: 'col-border',
  },
]
